const apiEndPoints = {
  getSignedURL: `/api/signedurl`
};

export default apiEndPoints;
